















import Vue from "vue";
import VClamp from "vue-clamp";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "TextClamp",
  components: { VClamp },
})
export default class TextClamp extends Vue {
  @Prop({ type: String, default: "div" })
  public tag!: string;

  @Prop({ type: Boolean, default: true })
  public autoresize!: boolean;

  @Prop({ type: Number, default: 3 })
  public maxLines!: number;

  @Prop({ type: String })
  public maxHeight!: string | number;

  @Prop({ type: String, default: "... " })
  public ellipsis!: string;

  @Prop({ type: Boolean, default: false })
  public expanded!: boolean;

  public moreClick(e: Event, expand: Function) {
    e.stopPropagation();
    expand();
  }
}
